import styled, { css } from 'styled-components';
import { regularWhite, fontWeightBold } from '../../../../ui-components/design-tokens';
import { device } from '../../../../ui-components/breakpoints';
import { PlayFocus } from 'app/ui-components/utils.styles';
import { playFontSize } from 'app/ui-components/typography/helpers';

export const ListItem = styled.li`
    display: inline-block;
    margin-top: -2px;
    margin-left: 0;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    @media ${device.GteSmall} {
        display: block;
        float: left;
    }

    ${(props) =>
        props.type === 'search' &&
        css`
            @media ${device.GteSmall} {
                display: none;
            }
        `}
`;

export const Link = styled.a`
    color: ${regularWhite};
    text-decoration: none;
    display: block;
    padding: 10px 8px;
    ${playFontSize(1.4)};
    ${PlayFocus}

    &:hover,
    &:active,
    &:visited {
        color: ${regularWhite};
    }

    &:hover {
        .no-touchevents & {
            text-decoration: underline;
        }
    }

    ${(props) =>
        props.isActive &&
        css`
            font-weight: ${fontWeightBold};
        `}

    @media ${device.GteSmall} {
        ${playFontSize(1.5)};
    }

    @media ${device.GteMedium} {
        padding: 10px 15px;
    }
`;
